// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"270":"c3cba187","756":"7fecb130","795":"fb0075d6","970":"53e93cb7"}[chunkId] + ".chunk.css";
};